var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04001 0.639999H29.23C30.88 0.639999 32.23 1.99 32.23 3.64V24.43C32.23 26.08 30.88 27.43 29.23 27.43H3.04001C1.39001 27.43 0.0400085 26.08 0.0400085 24.43V3.64C0.0400085 1.99 1.39001 0.639999 3.04001 0.639999ZM29.23 25.44C29.78 25.44 30.23 24.99 30.23 24.44V3.64C30.23 3.09 29.78 2.64 29.23 2.64H3.04001C2.49001 2.64 2.04001 3.09 2.04001 3.64V24.44C2.04001 24.99 2.49001 25.44 3.04001 25.44H29.23ZM14.36 11.17H26.4C26.95 11.17 27.4 11.62 27.4 12.17V21.27C27.4 21.82 26.95 22.27 26.4 22.27H14.36C13.81 22.27 13.36 21.82 13.36 21.27V12.17C13.36 11.62 13.81 11.17 14.36 11.17Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPip);
export default __webpack_public_path__ + "static/media/pip.50b1f806.svg";
export { ForwardRef as ReactComponent };